import { CardMedia as MuiCardMedia, CardMediaProps } from "@mui/material";
import { mergeSx } from "merge-sx";

export function CardMedia({ sx, ...props }: CardMediaProps) {
  return (
    <MuiCardMedia
      sx={mergeSx(
        (theme) => ({
          backgroundSize: "contain",
          width: theme.spacing(7),
          height: theme.spacing(7),
          flexShrink: 0,
          [theme.breakpoints.up(375)]: {
            marginRight: 1,
          },
          [theme.breakpoints.up("sm")]: {
            width: theme.spacing(8),
            height: theme.spacing(8),
            marginRight: theme.spacing(3),
          },
        }),
        sx
      )}
      {...props}
    />
  );
}
